(function () {
  var HEADER_ROOT = '#globalHeader';
  var DESKTOP_TARGET = '.utility_menu';
  var DESKTOP_BEFORE = '.search_wrapper';
  var MOBILE_TARGET = '.mobile_utility_links > div';
  var DESKTOP_SRC = '.orbe-source-desktop';
  var MOBILE_SRC = '.orbe-source-mobile';

  function tryMove() {
    var ds = document.querySelector(DESKTOP_SRC);
    var dt = document.querySelector(HEADER_ROOT + ' ' + DESKTOP_TARGET);
    if (dt && ds && !dt.contains(ds)) {
      var db = dt.querySelector(DESKTOP_BEFORE);
      if (db) {
        dt.insertBefore(ds, db);
      } else {
        dt.appendChild(ds);
      }
    }

    var ms = document.querySelector(MOBILE_SRC);
    var mt = document.querySelector(HEADER_ROOT + ' ' + MOBILE_TARGET);
    var ul = mt && mt.querySelector('ul');
    if (ul && ms && !ul.contains(ms)) {
      var li = ms.closest('li') || document.createElement('li');
      li.appendChild(ms);
      ul.appendChild(li);
    }
  }

  function init() {
    tryMove();

    var root = document.querySelector(HEADER_ROOT);
    if (!root) return;

    new MutationObserver(function () {
      tryMove();
    }).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
